module.exports = __webpack_public_path__ + "img/orange_color.be5030ca.webp";